import { Component, OnInit, Renderer2, TemplateRef } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import Math from "exact-math";
import { GlobalService } from "../../services/global.service";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import * as SecureLS from "secure-ls";
import { DatePipe } from "@angular/common";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { StorageService } from "../../services/storage.service";
@Component({
  selector: "app-course",
  templateUrl: "./course.component.html",
  styleUrls: ["./course.component.css"],
})
export class CourseComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  roleID = this.storageService.getRole();
  userID = this.ls.get("createdBy");

  alphaPattern = "[a-zA-Z .,]*";

  courseForm: FormGroup;

  showLoadMore = false;
  manualUpdate = true;
  swal: any;
  total_count = 0;
  courcreate: any;
  courseList: any[];
  getcourse: any;
  editcourse: any;
  is_active = false;
  deletecourse: any;
  editstatus = false;
  courupdate: any;
  courstatusupdate: any;
  editid: any;
  submitted = false;
  page: number = 1;
  page_size: number = 10;
  isactiveswitch: any;
  editbut = false;
  courname: any;
  desname: any;
  page_count = [];
  pageshow = true;
  htmlpageshow: boolean;
  total: number;
  p: number;
  pagedItems: any[];
  searchForm: FormGroup;
  chiparray: any = [];
  filtervalues: boolean;
  entryFields: boolean = false;
  createNew: boolean = true;
  rendererSpy: any;
  backendValidationErrors: any;

  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    public router: Router,
    private route: ActivatedRoute,
    private datepipe: DatePipe,
    private fb: FormBuilder,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2
  ) {}

  async ngOnInit() {
    this.searchForm = this.fb.group({
      id: [""],
      coursename: [""],
      description: [""],
    });
    this.courseForm = this.fb.group({
      id: [""],
      name: ["", [Validators.required]],
      description: ["", [Validators.required]],
      is_active: [""],
    });
    this.page = 1;
    this.courseForm.valueChanges.subscribe((data)=>{
      this.backendValidationErrors = null;
    })
    this.getCourse();
    await this.getPage(this.page, true);
  }

  openField() {
    this.entryFields = true;
    this.createNew = false;
    this.courseForm.reset();
    this.submitted = false;
  }
  openEdit() {
    this.entryFields = true;
    this.createNew = false;
    this.editbut = false;
    this.courseForm.reset();
    this.submitted = false;
  }

  cancelFields() {
    this.renderer.removeClass(document.body, "modal-open");
    this.entryFields = false;
    this.courseForm.reset();
    this.createNew = true;
  }

  async getPage(page: number, disableCall: boolean) {
    this.page = page;
    if(!disableCall) {
      await this.getCourse();
    }
    const res = await this.serverCall(this.courseList, page);
    this.total = this.total_count;
    this.p = page;
    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  get forms() {
    return this.courseForm.controls;
  }
  get forms1() {
    return this.searchForm.controls;
  }
  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
    if (this.pageshow === true) {
      this.page_count = [];
      let page_count = Math.ceil(this.total_count / this.page_size);
      if (page_count > 1) {
        this.htmlpageshow = true;
      } else {
        this.htmlpageshow = false;
      }
    }
  }
  Filter(courname, desname) {
    this.filtervalues = true;
    this.chiparray = [];
    if (this.courname != undefined && this.courname != "") {
      this.chiparray.push("Course :" + " " + this.courname);
    }

    if (this.desname != undefined && this.desname != "") {
      this.chiparray.push("Desc :" + " " + this.desname);
    }

    this.courname = courname;
    this.desname = desname;
    this.pageshow = true;
    this.page = 1;
    this.getCourse();
  }

  async createCourse(form: FormGroup) {
    this.submitted = true;
    if (this.courseForm.invalid) {
      return;
    }
    this.spinner.show();

    if (form.value.name.trim() == "") {
      Swal.fire("warning!", "Please Provide Valid Course Name", "warning");
    } else if (form.value.description.trim() == "") {
      Swal.fire("warning!", "Please Provide Valid Description", "warning");
    } else {
      const courseName = form.value.name.trim();
      const inputData = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        name: courseName,
        description: form.value.description,
        is_active: this.isactiveswitch
          ? this.isactiveswitch == true
            ? "1"
            : "0"
          : "0",
      };
      this.courcreate = await this.globalService.create(
        "course/create",
        inputData
      );

      if (this.courcreate["status"] === 200) {
        Swal.fire("Success!", this.courcreate["message"], "success");
        this.pageshow = true;
        this.getCourse();
        this.reset();
        this.entryFields = false;
        this.createNew = true;
        this.backendValidationErrors = null;
        this.renderer.removeClass(document.body, 'modal-open')
      } else if(this.courcreate["status"] === 422){
        this.backendValidationErrors = this.courcreate?.error["content"];
      } else {
        this.cancelFields();
        this.backendValidationErrors = null;
      }
    }
    
    this.spinner.hide();
  }

  res() {
    this.filtervalues = false;
    this.courname = null;
    this.desname = null;
    this.searchForm.reset();
    this.pageshow = true;
    this.backendValidationErrors = null;
    this.page = 1;
    this.getCourse();
  }
  getCourse() {
    this.spinner.show();
    if (this.page === 1) {
      this.courseList = [];
    }
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page,
      role_id: this.storageService.getRole(),
      description: this.desname ? this.desname : "",
      name: this.courname ? this.courname : "",
      page_size: this.page_size,
    };
    this.globalService.get("course/list", filter).then((data) => {
      this.getcourse = data;
      this.spinner.hide();
      this.total_count = this.getcourse["content"].count;
      if (this.getcourse["content"]["rows"].length < this.page_size) {
        this.showLoadMore = true;
      }

      if (this.getcourse["status"] === 200) {
        this.courseList = this.getcourse["content"]["rows"];
        if (this.pageshow === true) {
          this.page_count = [];
          let page_count = Math.ceil(this.total_count / this.page_size);
          if (page_count > 1) {
            this.htmlpageshow = true;
          } else {
            this.htmlpageshow = false;
          }
        }
      } else {
        this.showLoadMore = true;
      }
    });
  }
  switch(e) {
    this.isactiveswitch = e;
  }
  editCourse(id) {
    Swal.fire({
      title: "Edit ?",
      text: "Are you sure you want to edit this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.spinner.show();
        this.editbut = true;
        this.openField();
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
        };
        this.editcourse = await this.globalService.get("course/get", filter);
        let comp_details = this.editcourse["content"];

        if (this.editcourse["status"] === 200) {
          this.courseForm.controls["id"].setValue(comp_details.id);
          this.courseForm.controls["name"].setValue(comp_details.name);
          this.courseForm.controls["description"].setValue(
            comp_details.description
          );
          this.editid = comp_details.id;
          this.editstatus = comp_details.is_active;
        }
        this.spinner.hide();
      } else {
        this.cancelFields();
      }
    });
  }
  reset() {
    this.submitted = false;
    this.courseForm.reset();
    this.editstatus = false;
    this.isactiveswitch = false;
  }

  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getCourse();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getCourse();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getCourse();
  }

  CourseStatusUpdate(value: boolean, id) {
    this.spinner.show();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to Change Status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let status;
        this.manualUpdate = value;
        if (value == false) {
          status = "0";
        } else if (value == true) {
          status = 1;
        }
        const inputData = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id ? id : this.editid,
          is_active: status,
        };
        this.courstatusupdate = await this.globalService.update(
          "course/update/status",
          inputData
        );
        if (this.courstatusupdate["status"] === 200) {
          Swal.fire("Success!", this.courstatusupdate["message"], "success");
          this.pageshow = true;
          this.getCourse();
        }
        if (this.courstatusupdate["status"] != 200) {
          this.pageshow = true;
          this.getCourse();
        }
      } else {
        this.pageshow = true;
        this.getCourse();
      }
    });
    this.spinner.hide();
  }
  async updateCourse(form: FormGroup) {
    this.submitted = true;

    if (this.courseForm.invalid) {
      return;
    }
    this.spinner.show();
    if (form.value.name.trim() == "") {
      Swal.fire("warning!", "Please Provide Valid Course Name", "warning");
    } else if (form.value.description.trim() == "") {
      Swal.fire("warning!", "Please Provide Valid Description", "warning");
    } else {
      const courseName = form.value.name.trim();
      const inputData = {
        id: form.value.id,
        vendor_id: this.ls.get("vendor_id"),
        name: courseName,
        description: form.value.description,
        is_active: this.is_active ? this.is_active : this.editstatus,
        user_id: this.ls.get("createdBy"),
      };
      this.courupdate = await this.globalService.update(
        "course/update",
        inputData
      );

      if (this.courupdate["status"] === 200) {
        Swal.fire("Success!", this.courupdate["message"], "success");
        this.spinner.show();
        this.editbut = false;
        this.pageshow = true;
        this.getCourse();
        this.reset();
        this.entryFields = false;
        this.createNew = true;
        this.renderer.removeClass(document.body, 'modal-open')
      } else if(this.courcreate["status"] === 422){
        this.backendValidationErrors = this.courcreate?.error["content"];
      } else {
        this.cancelFields();
        this.backendValidationErrors = null;
      }
    }
    this.spinner.hide();
  }

  async deleteCourse(id) {
    this.spinner.show();
    Swal.fire({
      title: "Delete ?",
      text: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
        };
        this.deletecourse = await this.globalService.delete(
          "course/delete",
          filter
        );
        if (this.deletecourse["status"] === 200) {
          this.courseList = [];
          Swal.fire("Success!", this.deletecourse["message"], "success");
          this.pageshow = true;
          this.getCourse();
        }
      }
    });
    this.spinner.hide();
  }
  formAddReset() {
    this.courseForm.reset();
    this.editbut = false;
  }
  formUpdateReset() {
    this.courseForm.patchValue({
      id: this.editcourse["content"].id,
      name: this.editcourse["content"].name,
      description: this.editcourse["content"].description,
    });
    this.courseForm.reset();
    this.courseForm.get("id").setValue(this.editcourse["content"].id);
  }

  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getCourse();
  }
}
